import { IDatasource } from 'core-ts-types';
import { ITimeOccurrenceDatatype, IRawTimeOccurrenceDatatype } from './data_types';
import { TimeOccurrenceEngine } from '../../engines/time/time_engine';
import { TimeOccurrenceServant } from '../../servants/time/time_occurrence_servant';
import { IValidator, ICorrector } from '../../validation/contracts';

export class TimeOccurrenceDataSource implements IDatasource {
  public store: ITimeOccurrenceDatatype[];
  public memento: ITimeOccurrenceDatatype[];
  private isInTransaction: boolean;
  private saveValidators: IValidator[];
  private workValidators: IValidator[];

  constructor(
    private Interface: any,
    private TimeOccurrenceDTD: ITimeOccurrenceDatatype,
    private TimeOccurrenceBuilder: any,
    private ngTimeOccurrenceEngine: TimeOccurrenceEngine,
    private ngTimeOccurrenceServant: TimeOccurrenceServant,
    private timeConfigValidator: any
  ) {
    this.store = [];
    this.memento = [];
    this.saveValidators = [];
    this.workValidators = [];
    this.isInTransaction = false;
  }

  report(reportFn: (datasource: ITimeOccurrenceDatatype[]) => any): any {
    return reportFn(this.store);
  }

  write(store: any): IDatasource {
    return this;
  }

  initialize(): IDatasource {
    return this;
  }

  read(): ITimeOccurrenceDatatype[] {
    return this.store;
  }

  startTransaction(validators: IValidator[]) {
    this.saveValidators = [this.timeConfigValidator];
    this.addWorkValidators(validators);
    this.isInTransaction = true;
    this.memento = _.clone(this.store);
  }

  endTransaction(validators: IValidator[]) {
    this.workValidators = [];
    this.addSaveValidators(validators);

    if (!this.validate(this.saveValidators)) {
      this.revert();
    }

    this.isInTransaction = false;
  }

  addWorkValidators(validators: IValidator[]) {
    if (!_.isUndefined(validators)) {
      this.workValidators = this.workValidators.concat(validators);
    }
  }

  addSaveValidators(validators: IValidator[]) {
    if (!_.isUndefined(validators)) {
      this.saveValidators = this.saveValidators.concat(validators);
    }
  }

  validate(validators: Function[]) {
    return _.reduceRight(
      validators,
      (result: boolean, validator: IValidator) => {
        const validation = validator(this.store);
        if (validation.isValid && _.isFunction(validation.corrector)) {
          this.store = validation.corrector(this.store);
        }
        return result && validation.isValid;
      },
      true
    );
  }

  revert() {
    this.store = _.clone(this.memento);
  }

  addTime(timeOccurrence: ITimeOccurrenceDatatype, index: number): void {
    if (_.isUndefined(index)) {
      this.store.push(timeOccurrence);
    } else {
      this.store.splice(index, 0, timeOccurrence);
    }
    if (!this.validate(this.workValidators)) {
      this.revert();
    }
  }

  deleteTime(timeOccurrence: ITimeOccurrenceDatatype): void {
    _.remove(this.store, (timeBlock: ITimeOccurrenceDatatype) => timeBlock.trackingId === timeOccurrence.trackingId);
    if (!this.validate(this.workValidators)) {
      this.revert();
      return;
    }
  }

  buildTime(rawTimeOccurrence: IRawTimeOccurrenceDatatype): ITimeOccurrenceDatatype {
    return new this.TimeOccurrenceBuilder(rawTimeOccurrence);
  }

  buildTimes(rawTimeOccurrences: IRawTimeOccurrenceDatatype[]): ITimeOccurrenceDatatype[] {
    return _.map(
      rawTimeOccurrences,
      (rawTimeOccurrence: IRawTimeOccurrenceDatatype): ITimeOccurrenceDatatype => this.buildTime(rawTimeOccurrence)
    );
  }

  serializeTime(timeOccurrence: ITimeOccurrenceDatatype): IRawTimeOccurrenceDatatype {
    const timeOccurrenceSource = {
      appId: undefined,
      day_of_week: timeOccurrence.day._ordinal,
      from_tm: moment(timeOccurrence.from).format('HH:mm:ss'),
      to_tm: moment(timeOccurrence.to).format('HH:mm:ss'),
      repeats_every: timeOccurrence.repeats_every,
      trackingId: timeOccurrence.trackingId,
      beginMinutes: timeOccurrence.beginMinutes,
      endMinutes: timeOccurrence.endMinutes,
      bkgColorClass: timeOccurrence.bkgColorClass,
      content: timeOccurrence.content,
      group: timeOccurrence.group,
      type: timeOccurrence.type,
      isLocked: timeOccurrence.isLocked,
      isWarning: timeOccurrence.isWarning,
      isPreview: timeOccurrence.isPreview,
      isWaitlisted: timeOccurrence.isWaitlisted,
      isRegistered: timeOccurrence.isRegistered,
      icons: timeOccurrence.icons,
      hover: timeOccurrence.hover
    };
    return timeOccurrenceSource;
    // return this.Interface.serialize(this.TimeOccurrenceDTD, timeOccurrence);
    /*
    appId:undefined
    beginMinutes:0
    bkgColorClass:""
    content:""
    day_of_week:2
    endMinutes:0
    from_tm:"19:0:0"
    group:""
    hover:Object
    icons:Array(0)
    id:null
    isLocked:false
    isPreview:false
    isRegistered:false
    isWaitlisted:false
    isWarning:false
    repeats_every:1
    to_tm:"19:15:0"
    trackingId:"258"
    type:""
    */
  }

  serializeTimes(timeOccurrences: ITimeOccurrenceDatatype[]): IRawTimeOccurrenceDatatype[] {
    return _.map(timeOccurrences, (timeOccurrence: ITimeOccurrenceDatatype) => this.serializeTime(timeOccurrence));
  }
}

angular
  .module('ui-ng-calendar')
  .factory(
    'ngTimeOccurrenceDataSource',
    function (
      Interface: any,
      TimeOccurrenceDTD: ITimeOccurrenceDatatype,
      TimeOccurrenceBuilder: any,
      ngTimeOccurrenceEngine: TimeOccurrenceEngine,
      ngTimeOccurrenceServant: TimeOccurrenceServant,
      timeConfigValidator: any
    ): any {
      return new TimeOccurrenceDataSource(
        Interface,
        TimeOccurrenceDTD,
        TimeOccurrenceBuilder,
        ngTimeOccurrenceEngine,
        ngTimeOccurrenceServant,
        timeConfigValidator
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/datastore/time/time_datasource.ts